'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import useRegisterStore from '@/stores/register';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Spinner } from '@/components/ui/spinner';
import useRudderStackAnalytics from '@/hooks/useRudderAnalytics';
import useIsWebview from '@/hooks/use-is-webview';
import { useEffect, useRef } from 'react';
const RegisterSuccessStep = () => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["formData", "nextStep"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    formData,
    nextStep
  } = useRegisterStore(t0);
  const analytics = useRudderStackAnalytics();
  const [isWebView] = useIsWebview();
  const hasTrackedPageView = useRef(false);
  let t1;
  if ($[1] !== formData.name) {
    t1 = formData.name?.split(" ")[0] || "Usu\xE1rio";
    $[1] = formData.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const firstName = t1;
  const selectedAvatar = formData.avatarImage || "";
  let t2;
  let t3;
  if ($[3] !== analytics || $[4] !== isWebView) {
    t2 = () => {
      if (!analytics || hasTrackedPageView.current) {
        return;
      }
      hasTrackedPageView.current = true;
      analytics.track("Register Step", {
        step: "register_success",
        platform: isWebView ? "app" : "web"
      });
    };
    t3 = [analytics, isWebView];
    $[3] = analytics;
    $[4] = isWebView;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = `/images/avatars/${selectedAvatar}`;
  let t5;
  if ($[7] !== t4) {
    t5 = <AvatarImage src={t4} alt="Avatar" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AvatarFallback className="bg-gradient-to-br from-gray-700 to-gray-800"><Spinner size="lg" spinnerClassName="bg-white" /></AvatarFallback>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <Avatar className="size-32 border-4 border-white/10">{t5}{t6}</Avatar>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== firstName) {
    t8 = <h1 className="text-primary text-2xl font-bold">Bom trabalho, {firstName}!</h1>;
    $[12] = firstName;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="text-muted-foreground text-sm">Você já tá dentro! Bora personalizar sua experiência</p>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <div className="flex flex-col md:items-center gap-1">{t8}{t9}</div>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="flex flex-col gap-4 md:items-center max-w-sm pt-20">{t7}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== nextStep) {
    t12 = <div className="absolute bottom-0 left-0 w-full px-4 pb-12 md:relative md:max-w-xs"><Button type="button" onClick={nextStep} size="xl" rounded="full" className="w-full">Confirmar</Button></div>;
    $[20] = nextStep;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="min-h-screen w-full flex flex-col items-center justify-between"><div className="flex relative flex-col h-screen justify-center md:items-center md:justify-start gap-6 w-full px-4">{t11}{t12}</div></div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default RegisterSuccessStep;